// Confirm dialog (Plan 1 `ui.js` `TDS.confirm`) — Promise<boolean> API backed by a global singleton
// state rendered once by ConfirmHost.vue in App.vue, so any page can `await confirm({...})`.
import { reactive } from 'vue'

export interface ConfirmOptions {
  title?: string
  text?: string
  danger?: boolean
  okText?: string
  cancelText?: string
}

interface ConfirmState extends ConfirmOptions {
  visible: boolean
  resolve: ((value: boolean) => void) | null
}

const state = reactive<ConfirmState>({
  visible: false,
  title: '',
  text: '',
  danger: false,
  okText: 'Confirm',
  cancelText: 'Cancel',
  resolve: null,
})

export function useConfirm() {
  function confirm(opts: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      state.title = opts.title ?? 'Confirm'
      state.text = opts.text ?? 'Are you sure?'
      state.danger = !!opts.danger
      state.okText = opts.okText ?? 'Confirm'
      state.cancelText = opts.cancelText ?? 'Cancel'
      state.visible = true
      state.resolve = resolve
    })
  }
  function settle(value: boolean): void {
    state.visible = false
    state.resolve?.(value)
    state.resolve = null
  }
  return { state, confirm, settle }
}
